export default __webpack_public_path__ + "e5ce354f48115a19af382a46baf7ec2c.png";